import {CodeViewError} from '@github-ui/code-view-shared/components/CodeViewError'
import {useNavigate, useRouteError} from '@github-ui/react-router'
import {useEffect} from 'react'

export class CodeViewPathIsDirectoryError extends Error {
  constructor() {
    super('Path is a directory')
    this.name = 'CodeViewPathIsDirectoryError'
  }
}

const ERROR = {
  type: 'badResponseError' as const,
}

export function CodeViewBlobLayoutErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  useEffect(() => {
    if (error instanceof CodeViewPathIsDirectoryError) {
      navigate(window.location.pathname.replace('/blob', '/tree'), {replace: true})
    }
  }, [error, navigate])

  // Fallback while redirecting or for non-404 errors
  return error instanceof CodeViewPathIsDirectoryError ? null : <CodeViewError {...ERROR} />
}
